var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("headers.hearing_test")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-3" }, [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c("span", { staticClass: "header header-2" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("first_stage.adjust_message")) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticClass: "d-flex justify-content-center" }, [
                _c("span", { staticClass: "header header-4" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.correctAnswersText) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "transition-group",
                {
                  staticClass:
                    "row justify-content-md-center instruments-wrapper",
                  attrs: { name: "list", tag: "div" }
                },
                _vm._l(_vm.instruments, function(instrument) {
                  return _c(
                    "div",
                    {
                      key: instrument.id,
                      staticClass: "flip-card col-5 col-md-4 grid-instrument",
                      class: instrument.class,
                      on: {
                        click: function($event) {
                          return _vm.evaluateCalibrationAnswer(instrument)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "flip-card-inner" }, [
                        _c("div", { staticClass: "flip-card-front" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.getFullImagePath(instrument),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "flip-card-back" }, [
                          _c("i", { staticClass: "far fa-check-circle" })
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.answerWrong
            ? _c(
                "fade-transition",
                {
                  staticClass: "d-flex justify-content-center mt-3",
                  attrs: { duration: 250 }
                },
                [
                  _c("span", { staticClass: "header header-4 header-danger" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("first_stage.wrong_answer_message")) +
                        "\n          "
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }